
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from '@Components/Layout';
import Privacy from '@Components/TermsAndConditions/Privacy';
import { TermsConditionsWrapper } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import { NextPage } from 'next';
import { generatePageSeo } from 'next-seo.config';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { Col, Container, Row } from 'styled-bootstrap-grid';
interface Props {}

const PrivacyPolicy: NextPage<Props> = ({}) => {
  const { t, lang } = useTranslation('common');
  const { asPath } = useRouter();

  return (
    <Layout
      seoData={generatePageSeo({
        title: t('privacy-policy'),
        asPath,
        lang,
      })}
    >
      <TermsConditionsWrapper>
        <Container>
          <Row>
            <Col col={12}>
              <Privacy />
            </Col>
          </Row>
        </Container>
      </TermsConditionsWrapper>
    </Layout>
  );
};

 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PrivacyPolicy;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy-policy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  